export default __webpack_public_path__ + "static/media/vp.5027231c.jpeg";